export default __webpack_public_path__ + "static/media/logo.912b6f7a.svg";